import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Input from './Input';
import Select from './Select';
import { useCallback, useState } from 'react';

interface IFilter {
  fieldRef: React.RefObject<HTMLSelectElement>;
  orderRef: React.RefObject<HTMLSelectElement>;
  searchRef: React.RefObject<HTMLInputElement>;
  fieldOptions: { option: string; value: string }[];
  getFilteredData: any;
}

/**
 * @author taulmax
 * @date 2024.10.19
 * @description 필터 컴포넌트
 */
const Filter = ({
  fieldRef,
  orderRef,
  searchRef,
  fieldOptions,
  getFilteredData,
}: IFilter) => {
  const [searchText, setSearchText] = useState<string>('');
  const onChangeSearchText = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(e.target.value);
    },
    []
  );

  const orderSelectOptions = [
    { option: '내림차순', value: 'desc' },
    { option: '오름차순', value: 'asc' },
  ];

  const handleSearch = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      getFilteredData();
    },
    [getFilteredData]
  );

  return (
    <form onSubmit={handleSearch} className="!flex !items-center !gap-3">
      <div className="!flex !items-center !gap-2">
        <Select 
          selectRef={fieldRef} 
          options={fieldOptions}
          style={{ width: '120px' }}
        />
        <Select 
          selectRef={orderRef} 
          options={orderSelectOptions}
          style={{ width: '120px' }}
        />
        <div className="!relative">
          <Input
            inputRef={searchRef}
            value={searchText}
            onChange={onChangeSearchText}
            textAlign="left"
            width={250}
            placeholder="검색어를 입력해주세요"
            style={{ paddingRight: '40px' }}
          />
          <button
            type="submit"
            className="!absolute !right-1 !top-1/2 !-translate-y-1/2 !w-8 !h-8 !bg-blue-400 hover:!bg-blue-500 !rounded !flex !items-center !justify-center !transition-colors !border-0"
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} className="!text-white !text-sm" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default Filter;
